import { atom } from "jotai";

export const interventionSectionRenderIndexAtom = atom(1);
